import Vue from "vue";
import Vuex from "vuex";
import app from './modules/app'
import getters from "./getters.js";
import user from "./modules/user";
import userInfo from "./modules/userInfo"
 

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { app,user,userInfo },
  getters,
});
